import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { ROUTES } from "constants/routes";
import { useDictionary } from "hooks/use-dictionary";
import { useAuth } from "providers/auth";
import Layout from "components/layout";
import { useSnackbar } from "notistack";

const VIISPIntegration = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const dict = useDictionary();
  const { loginVIISP } = useAuth();
  const { enqueueSnackbar } = useSnackbar();
  const [message, setMessage] = useState(dict.common.loading);

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const isSuccess = searchParams.get("isSuccess");
    const ssoSessionId = searchParams.get("ssoSessionId");
    const errorMessage = searchParams.get("message");

    if (isSuccess === "1" && ssoSessionId) {
      exchangeSessionAndLogin(ssoSessionId);
    } else {
      showError(errorMessage);
    }
  }, []);

  const showError = (errorMessage?: string | null) => {
    setMessage(errorMessage || dict.messages.error);
    enqueueSnackbar({
      variant: "baseError",
      message: errorMessage || dict.messages.error,
      errors: [],
    });
  };

  const exchangeSessionAndLogin = async (ssoSessionId: string) => {
    const { success } = await loginVIISP(ssoSessionId);

    if (!success) {
      showError();

      return;
    }

    navigate(ROUTES.user);
  };

  return (
    <Layout>
      <div className="flex justify-center items-center h-screen text-2xl">{message}</div>
    </Layout>
  );
};

export default VIISPIntegration;
